<template>
    <div class="of-content3-item-right-larger of-content3-item">
        <div class="content">
            <h2
                class="title"
                :style="{ color: itemRightLarger.title.color }"
                v-html="itemRightLarger.title.text"
            ></h2>
            <p class="text" v-html="itemRightLarger.text"></p>
            <div
                class="button"
                @click="pageRedirect(itemRightLarger.button.link)"
                v-html="itemRightLarger.button.text"
                :data-ba-i="itemRightLarger.baIntelligenceTag"
            ></div>
        </div>
        <div class="main-svg">
            <img
                v-if="userTest"
                :src="itemRightLarger.newIcon"
                alt=""
                srcset=""
                @click="pageRedirect(itemRightLarger.button.link)"
            >
            <img
                v-else-if="!userTest"
                :src="itemRightLarger.mainSvg"
                alt=""
                srcset=""
                @click="pageRedirect(itemRightLarger.button.link)"
            >
        </div>
    </div>
</template>

<script>
    export default {
        name: 'item-right-larger',
        props: {
          view: {
            type: Object,
          },
          userTest: {
            type: Boolean,
          },
        },
        data() {
            return {
                mainSvg: '/internacional/public/office4/img/onboarding-funnel/content-3/ic-premium-funnel.svg',
                title: {
                  text: 'Builderall Premium Funnels',
                  color: '#B07EFF' // color1
                },
                text: 'Affiliate funnels that are optimized for conversions. When you use the affiliate link for these funnels, they are designed to bring in new Builderall members with you as their sponsor. You can also brand the affiliate link with your own domain.',
                button: {
                  text: 'Learn more',
                  link: '#'
                },
                baIntelligenceTag: 'fc-c3-builderall-premium-funnels-us-id'
            }
        },
        methods: {
            pageRedirect: function (link){
                window.open(link, "_blank")
            }
        },
        computed: {
            itemRightLarger: function () {
                return (this.view !== undefined && this.view !== null) ? this.view : this.$data
            }
        },
        created(){

        },
        mounted(){

        }
    }
</script>

<style scoped lang="scss">
    @import "../../../../../scss/office";

    /* editar CSS */
    .of-content3-item-right-larger{
        font: inherit;

        min-height: 70em; /* 700px */

        display: grid;
        grid-template-columns: 7fr 3fr;
        grid-template-rows: auto;
        justify-items: stretch;
        align-items: start;
        justify-content: stretch;
        align-content: center;
        column-gap: 9.5em; /* 95px */

        margin: 0 8.5em; /* 0 85px */

        .main-svg{
            font: inherit;
            text-align: left;

            grid-column-start: 2;
            grid-column-end: 3;

            img{
                font: inherit;
                width: 30em; /* 300px */
                height: auto;

                &:hover{
                    cursor: pointer;
                }
            }
        }

        .content{
            font: inherit;
            text-align: right;
            box-sizing: border-box;


            grid-column-start: 1;
            grid-column-end: 2;

            display: flex;
            flex-direction: column;
            align-items: flex-end;
            justify-content: center;

            h2,
            .title{
                font:inherit;
                display: inline-block;

                font-size: 5em; /*50px*/;
                font-family: "Mulish";
                font-weight: 700;
                line-height: 1.2;

                margin: 0 0 0.22em 0; /* 0 0 11px 0 */
                padding: 0;

                max-width: 90.3401361%;/* 664px */
            }

            p,
            .text{
                font: inherit;
                display: inline-block;

                color: $of-color11;

                font-size: 3em; /*30px*/
                font-weight: 400;
                line-height: 1.2;

                margin: 0 0 1.066666667em 0; /* 0 0 32px 0 */
                padding: 0;

                max-width: 98.1679389%; /* 643px */
            }

            .button {
                font: inherit;
                font-size: 1.4em; /* 14px */
                display: inline-block;
                background: $of-color1;
                padding: 0.714285714em 2.285714286em; /* 10px 32px */
                color: $of-color3;
                border-radius: 4px;
                transition: 1s all ease;
                margin: 0;
                text-align: center;
                &:hover {
                    cursor: pointer;
                    box-shadow: 0px 0px 7px -2px $of-color1;
                }
            }
        }
    }

    .of-content3-item-right-larger:last-child{
        font: inherit;
        margin-bottom: 2em; /* 20px */
    }

    @media (max-width: 768px) { /* smartphones e tablets */
        .of-content3-item-right-larger{
            font: inherit;

            margin: 0 5%;

            grid-template-columns: 1fr;
            grid-template-rows: repeat(2, auto);
            align-items: start;
            justify-items: center;
            column-gap: 0;

            width: 90%;

            .main-svg{
                font: inherit;

                grid-row-start: 1;
                grid-column-start: 1;

                width: 80%;

                padding-top: 6.2em;/* 62px */

                img{
                    width: 100%;
                    height: auto;
                }
            }
            .content{
                font: inherit;

                grid-row-start: 2;
                grid-column-start: 1;

                width: 80%;
                display: block;
                text-align: center;

                padding: 6.2em 0; /* 62px */

                h2,
                .title{
                    max-width: 100%;
                }

                p,
                .text{
                    max-width: 80%;
                }

                .button{
                    display: block;
                    font-size: 1.92em; /* 19.2px */
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// resources/office/js/components/dashboard/onboardingFunnel/content-3/item-right-larger.vue